import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import Techstack from "./Techstack";
import Aboutcard from "./AboutCard";
import developer from "../../Assets/altaf.png";
import { SKILLS, TOOLS ,SKILL} from "../../Constants";
import "aos/dist/aos.css"
// import GitHubCalendar from "react-github-calendar";

import Aos from "aos";

// added

function About({tech}) {

  React.useEffect(() => {
    
    Aos.init({duration:2000})
  
    
  }, [])

  return (
    <Container fluid className="about-section" style={{border:"", background:""}} >
      <Container>
        <Row style={{ justifyContent: "center",
         padding: "10px",
        //  border:"1px solid red",

         borderRadius:"10px", 
         background:"#161515"
          }} data-aos="fade">
          
          <Col md={5} style={{ paddingBottom: "0px",background:"#161515" ,display:"flex",alignItems:"center" , justifyContent:"center"}} className="about-img module">
            <img src={developer} alt="about"  className="image-style" />
          </Col>
          <Col
            md={7}
            style={{
              justifyContent: "center",
              paddingTop: "30px",
              paddingBottom: "50px",
            
            }}
          >
            <h1 style={{ fontSize: "2.1em", paddingBottom: "20px",color:"#3765ffd8"}}>
              <strong className="purple" style={{ color:"white" }} >About </strong>ME
           
            </h1>
           

            <Aboutcard />
          </Col>
        
        </Row>
        
{/* skills start */}

        <Row ref={tech} data-aos="fade">
        <Col className="skill-wrapper backgroundblack"  >
            <h1 className="project-heading backgroundblack text-rainbow-animation1" >
              Tech-Stack
            </h1>
            <div style={{display:"flex",color:"black",justifyContent:"space-around",gap:"10px",flexWrap:"wrap" }}>

           

            {SKILL.map((tool, index) => (
             
             <div>
                <div style={{  padding:"10px" }} className="box gradient-border gradient-border:after">
              <img height="50px" alt="m" width="50px" src={tool.img} />
                <p style={{diplay:"flex", padding:"0px" ,margin:"0px"}} >{tool.name}</p>
               </div>

               </div>
              
            ))}
           

            </div>
          </Col>
        </Row>

 {/* skills end */}

        <div style={{margin:"0px",padding:"5px",boxSizing:"border-box" ,width:"100%",minWidth:"100%",maxWidth:"100%"}}>
        <Row  className="skill-tools-wrapper" data-aos="fade-up" >
          <Col className="skill-wrapper backgroundblack" >
            <h1 className="project-heading backgroundblack text-rainbow-animation">
              Skills
            </h1>
            <div className="skill-wrapper-grid backgroundblack" style={{display:"grid",gridTemplateColumns:"repeat(2,1fr)" }}>
            {SKILLS.map((skill, index) => (
              <Techstack
                name={skill.name}
                initialRating={skill.initialRating}
                key={index}
              />
            ))}
            </div>
           
           <div style={{marginTop:"80px",alignitems:"center",justifyContent:"space-around"}} className="githubstatic">
          <img align="center" style={{width:"48%",marginRight:"10px"}}  src= "https://github-readme-stats.vercel.app/api?username=altaf100001&show_icons=true&locale=en" alt="altaf100001" />
           <img align="center" style={{width:"48%"}} src= "https://github-readme-stats.vercel.app/api/top-langs?username=altaf100001&show_icons=true&locale=en&layout=compact" alt="altaf100001" />
           </div>

           <div>
           {/* <GitHubCalendar username="altaf100001" year={new Date().getFullYear} /> */}
           </div>

          </Col>
         
         
        </Row>

        <Row data-aos="fade">
        <Col className="skill-wrapper backgroundblack"  >
            <h1 className="project-heading backgroundblack text-rainbow-animation1" >
              Tools I use
            </h1>
            <div style={{display:"flex",color:"black",justifyContent:"space-around",gap:"10px",flexWrap:"wrap" }}>

           

            {TOOLS.map((tool, index) => (
             
             
                <div style={{  padding:"10px" }} className="box gradient-border gradient-border:after">
                <p style={{diplay:"flex", padding:"0px" ,margin:"0px"}} >{tool}</p>
               </div>
              
            ))}
           

            </div>
          </Col>
        </Row>
        </div>
      </Container>
    </Container>
  );
}

export default About;
